import { Spin } from "antd";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";
import ReactS3Client from "react-aws-s3-typescript";
import { FileUploader } from "react-drag-drop-files";
import { useForm, SubmitHandler } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import Breadcrumb from "Components/Breadcrums";
import FormControl from "Components/FormControl";
import Imagepreview from "Components/ImagePreview";
import Upload from "Components/UploadDesign/upload";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";

import { config } from "../../../s3config";
import { breadcrumbItems, formFields } from "./Constant";
import { categoryInputs } from "./Types";
import { add_Category, update_Category, uploadImage } from "Services/Requests";
import Styles from "Styles/Styles.module.css";

window.Buffer = window.Buffer || require("buffer").Buffer;

function Addcategory() {
    const navigate = useNavigate();
    const fileTypes = ["JPG", "PNG", "JPEG"];
    const { type } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const [categoryImg, setcategoryImg] = useState("");
    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        resetField,
        reset,
        watch,
        setError,
    } = useForm<categoryInputs>();

    const handleChange = (files: any) => {
        setErrorMsg("");
        let maxSize = 2 * 1024 * 1024;
        if (files.size > maxSize) {
            alert("File size cannot be greater than 2 MB");
            return;
        }

        const timestamp = Date.now();
        const fileName = `${timestamp}`;
        const s3 = new ReactS3Client({
            ...config,
            dirName: "categoryImages",
        });
        let formData = new FormData();
        formData.append("image", files);
        formData.append("folder", "categoryImages");
        setLoading(true);
        uploadImage(formData)
            .then((res: any) => {
                setValue("image_url", res.data?.image);
                setcategoryImg(res.data?.url);
                setLoading(false);
            })
            .catch((err: any) => {
                alert(err);
                setLoading(false);
            });
    };

    const onSubmit: SubmitHandler<categoryInputs> = async (data) => {
        if (!categoryImg) {
            setErrorMsg("Please Upload File");
            return;
        }
        try {
            setLoading(true);
            let response;
            if (type === "edit") {
                response = await update_Category(
                    location.state?.category_id,
                    data
                );
            } else {
                response = await add_Category(data);
            }
            if (response?.data?.status === 1) {
                Toast(response?.data?.Message, "success");
                navigate(-1);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const watchData = watch();

    useEffect(() => {
        if (type === "edit") {
            let formData = location.state;
            formData = {
                ...formData,

                image_url: String(formData.image_url).split("/")[
                    String(formData.image_url).split("/").length - 1
                ],
            };
            reset({ ...formData });
            setcategoryImg(location.state?.image_url);
        }
    }, [type, location.state, reset]);

    return (
        <div className={Styles["Add_form_wrapper"]}>
            <Imagepreview
                handleCancel={() => setIsModalVisible(false)}
                selectedImage={categoryImg}
                isModalVisible={isModalVisible}
                title="category"
            />
            <h3>
                <span style={{ textTransform: "capitalize" }}>{type}</span>{" "}
                category
            </h3>
            <Breadcrumb items={breadcrumbItems} type={type} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    <h4>category</h4>
                    <FormControl
                        key={"Category Name"}
                        label={"Category Name"}
                        name={"category_name"}
                        register={register}
                        errors={errors["category_name"]}
                        requiredMessage={"this field is required"}
                        type={"text"}
                    />
                    {type == "edit" && (
                        <FormControl
                            key={"status"}
                            label={"Status"}
                            name={"status"}
                            register={register}
                            errors={errors["status"]}
                            requiredMessage={"this field is required"}
                            type={"select"}
                            options={[
                                { value: 1, label: "Active" },
                                { value: 0, label: "Inactive" },
                            ]}
                        />
                    )}
                    <div className={Styles["form_control"]}>
                        <label htmlFor="Photo">Photo</label>
                        <FileUploader
                            handleChange={handleChange}
                            name="file"
                            types={fileTypes}
                            children={Upload}
                        />
                        {categoryImg && (
                            <div className={Styles["remove_upload"]}>
                                <div onClick={() => setIsModalVisible(true)}>
                                    <img src={categoryImg} alt="category" />
                                    {/* <p>{watchData.image_url}</p> */}
                                </div>
                                <button
                                    onClick={() => {
                                        resetField("image_url");
                                        setcategoryImg("");
                                    }}>
                                    <MdDelete />
                                </button>
                            </div>
                        )}
                    </div>
                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>

                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button>{type === "edit" ? "Update" : "Add"}</button>
                )}
            </form>
        </div>
    );
}

export default Addcategory;
